import React, { useEffect, useState } from 'react';
import DescriptionTitle from '../../Shared/DescriptionTitle';
import { Grid2 } from '@mui/material';
import useQuery from '../../Shared/UseQuery';
import { dataService } from '../../../Services/data/data.service';
import MeasurementBlocks from './MeasurementBlocks';
import { connect } from 'react-redux';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import TableRowsIcon from '@mui/icons-material/TableRows';
import Squares from './squares.svg';
import { controlTypes } from '../../../Config/constants';

export const PerformMeasurementPage = (props) => {

    let query = useQuery();
    let qr = query.get("qr");
    const [measurementBlocks, setMeasurementBlocks] = useState([]);
    const [projectName, setProjectName] = useState([]);
    const [resourceName, setResourceName] = useState([]);
    const [projectId, setProjectId] = useState([]);
    const [refresh, setRefresh] = useState(false)
    const [viewSize, setViewSize] = useState(6)
    const [displaySize, setDisplaySize] = useState(3);
    const [activeProject, setActiveProject] = useState(true);
    const [autosize, setAutosize] = useState(true);
    const [toggleRefresh, setToggleRefresh] = useState(false);

    const [keyRequired, setKeyRequired] = useState(false);
    const [keyFound, setKeyFound] = useState(false);
    const [currentKey, setCurrentKey] = useState(null);

    const [validSubscription, setValidSubscription] = useState(false);
    const [generalPageError, setGeneralPageError] = useState(null);

    useEffect(() => {
        dataService.getSubscriptionByProjectQr(qr).then((result) => {
            if (result.success) {
                setValidSubscription(true);
                finishSetup();
            } else {
                setGeneralPageError("You don't have a valid subscription. Without valid subscription you can not take any measurements.");
                setValidSubscription(false);
            };
        }).catch(error => {
            setGeneralPageError("Something went wrong. Please try again later.");
        });
    }, [qr, toggleRefresh]); // eslint-disable-line react-hooks/exhaustive-deps

    const finishSetup = () => {
        dataService.getProjectDetailWithComments(qr).then(res => {
            var boolKeyRequired = false;
            var boolKeyFound = false;

            //check if the keyvalue is required for this project --> If so, check if we have already saved a value, if so we can start with other measurments, IF NOT Warn the user that they have to select the correct value first
            if (res.details !== null && res.details !== undefined && res.details.some(x => x.isParent)) {
                boolKeyRequired = true;
                var keyValue = res.details.find(x => x.isParent);
                if (keyValue.measurements !== null && keyValue.measurements !== undefined && keyValue.measurements.length > 0 && keyValue.measurements.some(x => x !== null && x.running)) {
                    boolKeyFound = true;
                    // setCurrentKey(keyValue.measurements.find(x => x !== null && x.running).textValue);

                    setCurrentKey(keyValue.measurements.filter(x => x !== null && x.running).sort((a, b) => new Date(b.startTime) - new Date(a.startTime))[0]?.textValue);
                    setKeyFound(boolKeyFound);
                }

            }
            setKeyRequired(boolKeyRequired);

            //Check if the project is still active
            let currentDate = new Date();
            let active = dateRange(new Date(res.timeRangeBegin), new Date(res.timeRangeEnd), currentDate, currentDate);
            if (active) {
                setActiveProject(true);
            }
            else {
                setActiveProject(false);
            }
            setProjectId(res.id);
            setProjectName(res.projectName);
            setResourceName(res.resourceDescription);

            let tempDetails = [...res.details];
            tempDetails.forEach(detail => {
                detail.running = true;
                detail.currencyId = res.currencyId;
                if (detail.measurements.length > 0 && detail.measurements[0] !== null && !refresh && detail.measurements[detail.measurements.length - 1].running === true) {
                    if (detail.controlTypeId === controlTypes.COUNTER) {
                        //Counter
                        detail.value = detail.measurements[detail.measurements.length - 1].integerValue;
                        let comments = detail.measurements.filter(measurement => measurement.running).map((measurement, index) => ({ comment: measurement.commentText ? measurement.commentText : "", image: measurement.commentImage ? "data:image/png;base64," + measurement.commentImage : "", index: index + 1, insertedOn: measurement.commentInsertedOn }));
                        detail.comments = comments;
                    } else if (detail.controlTypeId === controlTypes.STOPWATCH) {
                        //Timer         
                        if (detail.measurements[detail.measurements.length - 1].stopValue === null) {
                            detail.value = "0";
                            detail.stopValue = new Date(Date.now());
                            detail.startValue = new Date(Date.now());
                            let comments = detail.measurements.map((measurement, index) => ({ comment: measurement.commentText ? measurement.commentText : "", image: measurement.commentImage ? "data:image/png;base64," + measurement.commentImage : "", index: index + 1, insertedOn: measurement.commentInsertedOn }));
                            detail.comments = comments;
                        } else {
                            detail.value = detail.measurements[detail.measurements.length - 1].integerValue;
                            detail.stopValue = new Date(detail.measurements[detail.measurements.length - 1].stopValue);
                            detail.startValue = new Date(detail.measurements[detail.measurements.length - 1].startValue);
                            let comments = detail.measurements.map((measurement, index) => ({ comment: measurement.commentText ? measurement.commentText : "", image: measurement.commentImage ? "data:image/png;base64," + measurement.commentImage : "", index: index + 1, insertedOn: measurement.commentInsertedOn }));
                            detail.comments = comments;
                        }
                        let comments = detail.measurements.filter(measurement => measurement.running).map((measurement, index) => ({ comment: measurement.commentText ? measurement.commentText : "", image: measurement.commentImage ? "data:image/png;base64," + measurement.commentImage : "", index: index + 1, insertedOn: measurement.commentInsertedOn }));
                        detail.comments = comments;
                    } else if (detail.controlTypeId === controlTypes.FREETEXT) {
                        //Free text
                        detail.value = detail.measurements[detail.measurements.length - 1].textValue;
                    }
                    else if (detail.controlTypeId === controlTypes.SCANNER) {
                        // Scanner
                        detail.value = detail.measurements[detail.measurements.length - 1].textValue;
                        let comments = detail.measurements.filter(measurement => measurement.running).map((measurement, index) => ({ comment: measurement.commentText ? measurement.commentText : "", image: measurement.commentImage ? "data:image/png;base64," + measurement.commentImage : "", index: index + 1, insertedOn: measurement.commentInsertedOn }));
                        detail.comments = comments;
                    }
                    else if (detail.controlTypeId === controlTypes.CAMERA) {
                        // Camera
                        detail.value = detail.measurements[detail.measurements.length - 1].textValue;
                        let comments = detail.measurements.filter(measurement => measurement.running).map((measurement, index) => ({ comment: measurement.commentText ? measurement.commentText : "", image: measurement.commentImage ? "data:image/png;base64," + measurement.commentImage : "", index: index + 1, insertedOn: measurement.commentInsertedOn }));
                        detail.comments = comments;
                    }
                }
                else {
                    setCurrentKey(null)
                    setKeyFound(false);
                    if (detail.controlTypeId === controlTypes.COUNTER) {
                        //Counter
                        detail.value = "0";
                        let comments = [];
                        detail.comments = comments;
                    } else if (detail.controlTypeId === controlTypes.STOPWATCH) {
                        //Timer                             
                        detail.value = "0";
                        detail.stopValue = new Date(Date.now());
                        detail.startValue = new Date(Date.now());
                        let comments = [];
                        detail.comments = comments;
                    } else if (detail.controlTypeId === controlTypes.FREETEXT) {
                        //Free text
                        detail.value = "";
                    }
                    else if (detail.controlTypeId === controlTypes.SCANNER) {
                        // Scanner
                        detail.value = "";
                        let comments = [];
                        detail.comments = comments;
                    }
                    else if (detail.controlTypeId === controlTypes.CAMERA) {
                        // Camera
                        detail.value = "";
                        let comments = [];
                        detail.comments = comments;
                    }
                }
            });
            setMeasurementBlocks(tempDetails);
        });

        function dateRange(a_start, a_end, b_start, b_end) {
            if (a_start <= b_start && b_start <= a_end) return true; // b starts in a
            if (a_start <= b_end && b_end <= a_end) return true; // b ends in a
            if (b_start < a_start && a_end < b_end) return true; // a in b
            if (datesAreOnSameDay(a_start, b_start)) return true;
            if (datesAreOnSameDay(b_end, a_end)) return true;
            return false;
        }

        const datesAreOnSameDay = (first, second) =>
            first.getFullYear() === second.getFullYear() &&
            first.getMonth() === second.getMonth() &&
            first.getDate() === second.getDate();

        const display1Min = window.matchMedia('(min-width: 720px)');
        const display2Min = window.matchMedia('(min-width: 1000px)');
        const display3Min = window.matchMedia('(min-width: 1300px)');

        const listener = () => {
            if (!display1Min.matches) {
                setDisplaySize(0)
                setAutosize(true)
            }
            if (display1Min.matches && !display2Min.matches) {
                setDisplaySize(1)
                setAutosize(true)
            }
            if (display2Min.matches && !display3Min.matches) {
                setDisplaySize(2)
                setAutosize(true)
            }
            if (display3Min.matches) {
                setDisplaySize(3)
                setAutosize(true)
            }
            if (autosize) {
                if (!display1Min.matches) { setViewSize(12) }
                if (display1Min.matches) { setViewSize(6) }
                if (display2Min.matches) { setViewSize(4) }
                if (display3Min.matches) { setViewSize(3) }
            }
        }

        listener();
        window.addEventListener('resize', listener);
        return () => window.removeEventListener('resize', listener);
    }

    const viewSizeFunction = (blockWidth) => {
        setViewSize(blockWidth !== null ? blockWidth : 6);
        setAutosize(false);
    }

    const TitleStyle = {
        background: "#FFFFFF",
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '15px',
    }
    const Style = {
        textAlign: "center",
        background: "#FFFFFF",
        borderRadius: "8px",
        margin: "1.5rem",
        padding: "1.5rem"
    }

    const TitleTextStyle = {
        fontSize: "1.5rem",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "48px",
        color: "#1D3557",
        width: '50%',
        display: 'flex',
        alignItems: 'center',
        marginLeft: "1.5rem",
    }

    const noSubscriptionContainer = {
        padding: "40px",
    }

    const errorContainer = {
        width: "100%",
        backgroundColor: "#FDF3F3",

        border: "1px solid #FBE5E5",
        borderRadius: "6px",

        marginBottom: "16px",
        padding: "12px",
    }

    const errorMessage = {
        fontSize: "16px",
        color: "#D84949"
    }

    const refreshMeasurements = () => {
        setRefresh(true);
        setToggleRefresh(!toggleRefresh);
    }

    return (
        validSubscription ? (
            <div style={{ position: "absolute", top: props.loggedInState ? "0" : "0", width: "100%" }}>
                <div style={TitleStyle}>
                    <div style={TitleTextStyle} >
                        <h1>{resourceName}</h1>
                    </div>
                    <div style={{ float: 'right', marginRight: '10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100%' }}>
                            <div style={{ fontSize: "10px", width: '100%', textAlign: 'center' }}>
                                Choose your preferred block width:
                            </div>
                            <ToggleButtonGroup onChange={(e, newValue) => viewSizeFunction(newValue)} exclusive value={viewSize} defaultValue={6}>
                                <ToggleButton sx={{ borderRadius: 0, border: '1px solid rgb(224, 224, 224) !important', padding: '10px !important' }} value={12}>
                                    <TableRowsIcon color='#8D8D8D' />
                                </ToggleButton>
                                <ToggleButton sx={{ borderRadius: 0, border: '1px solid rgb(224, 224, 224) !important', padding: '10px !important' }} value={6}>
                                    <img src={Squares} style={{ padding: '2px' }} alt="Square Icon" />
                                </ToggleButton>
                                {(displaySize === 2 || displaySize === 3) &&

                                    <ToggleButton sx={{ borderRadius: 0, border: '1px solid rgb(224, 224, 224) !important', padding: '10px !important' }} value={4} >
                                        <SvgIcon>
                                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                                                <path fill="currentcolor" d="M16 5v6h5V5m-11 6h5V5h-5m6 13h5v-6h-5m-6 6h5v-6h-5m-6 6h5v-6H4m0-1h5V5H4v6Z" />
                                            </svg>
                                        </SvgIcon>
                                    </ToggleButton>
                                }
                                {displaySize === 3 &&
                                    <ToggleButton sx={{ borderRadius: 0, border: '1px solid rgb(224, 224, 224) !important', padding: '10px !important' }} value={3}>
                                        <SvgIcon>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24s">
                                                <path d="M0 0h24v24H0z" fill="none" />
                                                <path d="M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z" />
                                            </svg>
                                        </SvgIcon>
                                    </ToggleButton>

                                }
                            </ToggleButtonGroup>
                        </div>
                    </div>
                </div>
                {
                    activeProject === true ?
                        <div style={Style}>
                            <Grid2 container>
                                <Grid2 item size={12}>
                                    {(measurementBlocks !== undefined && measurementBlocks.length >= 1) && <MeasurementBlocks {...props} projectId={projectId} projectGuid={qr} data={measurementBlocks} keyFound={keyFound} setKeyFound={setKeyFound} keyRequired={keyRequired} currentKey={currentKey} setCurrentKey={setCurrentKey} refreshMeasurements={refreshMeasurements} toggleRefresh={toggleRefresh} view={viewSize} />}
                                </Grid2>
                            </Grid2>
                        </div>
                        :
                        <div style={Style}>
                            <Grid2 container>
                                <Grid2 item size={12}>
                                    <h1 style={{ color: "red" }}>{projectName + " is not active anymore."} </h1>
                                    <DescriptionTitle Text="Contact the project owner to change the date when this project takes places." />
                                </Grid2>
                            </Grid2>
                        </div>
                }
            </div>
        ) : (
            <div style={noSubscriptionContainer}>
                {generalPageError && (
                    <div style={errorContainer}>
                        <p style={errorMessage}>{generalPageError}</p>
                    </div>
                )}
            </div>

        )
    )
}

const mapStateToProps = state => ({
    settings: state.settings
})

export default connect(
    mapStateToProps
)(PerformMeasurementPage);





